<template>
    <div class="mUinitBusiness">
        <div class="topTitle">
            <h3>个体商户入驻</h3>
            <p>请认真填写申请信息，以便我们为您提供更好的服务！</p>
        </div>
        <!-- 新增（2026-10-18，第 118 条）：展示入口页选择的「开通功能」 -->
        <div v-if="funcText()" style="margin: 8px 5% 0; padding: 10px 12px; background: #fdf6e3; border: 1px solid #f0d9a8; color: #8a6d3b; font-size: 13px;">
            已选择开通：{{ funcText() }}（如需修改请返回上一步重新选择）
        </div>
        <div class="centBox">
            <el-steps :active="active" align-center>
                <el-step @click.native="changeActive((index = 1))" title="店铺信息"></el-step>
                <el-step @click.native="changeActive((index = 2))" title="经营者信息"></el-step>
            </el-steps>
            <div class="mFormBox">
                <div class="shopInfo" v-show="active === 1">
                    <div class="form">
                        <div class="inputItem">
                            <div class="labelTit">
                                <label>
                                    <i>*</i>
                                    店铺名称：
                                </label>
                            </div>
                            <input type="text" v-model="personalForm.shopName" placeholder="请输入店铺名称" />
                        </div>
                        <div class="inputItem">
                            <div class="labelTit">
                                <label>
                                    <i>*</i>
                                    客服电话：
                                </label>
                            </div>
                            <input type="text" v-model="personalForm.servicePhone" placeholder="请输入客服电话" />
                        </div>
                        <div class="inputItem">
                            <div class="labelTit">
                                <label>
                                    <i>*</i>
                                    店铺负责人：
                                </label>
                            </div>
                            <input type="text" v-model="personalForm.chargePersonName" placeholder="请输入店铺负责人" />
                        </div>
                        <div class="inputItem">
                            <div class="labelTit">
                                <label>
                                    <i>*</i>
                                    负责人电话：
                                </label>
                            </div>
                            <input type="text" v-model="personalForm.chargePersonPhone" placeholder="请输入负责人电话" />
                        </div>
                        <div class="inputItem arrow">
                            <div class="labelTit">
                                <label>
                                    <i>*</i>
                                    店铺地址：
                                </label>
                            </div>
                            <input @click="showPopup" @focus="noBomBox" v-model="shopAdress" type="text" placeholder="请选择所在地区" />
                            <span class="iconfont">&#xe6ab;</span>

                            <!-- 详细地址 + 地图选点按钮 -->
                            <div style="display: flex; align-items: center; margin-top: 10px">
                                <input
                                    type="text"
                                    v-model="personalForm.storeAddressDetail"
                                    placeholder="请输入详细地址或点击右侧按钮从地图选择"
                                    style="flex: 1; border-bottom: 1px solid #f6f4f7; height: 50px; line-height: 50px; font-size: 13px; color: #666666; padding-left: 10px"
                                />
                                <button
                                    type="button"
                                    @click="openMapDialog"
                                    style="margin-left: 8px; height: 34px; padding: 0 10px; border: none; background: #333333; color: #ffebc4; font-size: 12px"
                                >
                                    地图选点
                                </button>
                            </div>
                            <p v-if="personalForm.lng && personalForm.lat" style="margin-top: 6px; font-size: 12px; color: #999">
                                已选择坐标：{{ personalForm.lng }}, {{ personalForm.lat }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="subjectInfo" v-show="active === 2">
                    <div class="form">
                        <div class="inputItem">
                            <div class="labelTit">
                                <label>
                                    <i>*</i>
                                    经营者姓名：
                                </label>
                            </div>
                            <input v-model="personalForm.personalName" type="text" placeholder="请输入经营者姓名" />
                        </div>
                        <div class="inputItem arrow">
                            <div class="labelTit">
                                <label>
                                    <i>*</i>
                                    证件类型：
                                </label>
                            </div>
                            <input @focus="noBomBox" v-model="idType" type="text" placeholder="请选择证件类型" @click="idTypeShowFn" />
                            <span class="iconfont">&#xe6ab;</span>
                        </div>
                        <div class="inputItem">
                            <div class="labelTit">
                                <label>
                                    <i>*</i>
                                    身份证号码：
                                </label>
                            </div>
                            <input v-model="personalForm.personalIdCard" type="text" placeholder="请输入居民身份证号" />
                        </div>
                        <div class="inputItem arrow">
                            <div class="labelTit">
                                <label>
                                    <i>*</i>
                                    身份证有效期：
                                </label>
                            </div>
                            <input @focus="noBomBox" v-model="personalForm.personalCardStartTime" type="text" placeholder="请选择身份证开始时间" @click="selectIdStartDateBtn" />
                            <span class="iconfont">&#xe6ab;</span>
                        </div>
                        <div class="inputItem arrowTime">
                            <input @focus="noBomBox" v-model="personalForm.personalCardEndTime" type="text" placeholder="请选择身份证有效期结束时间" @click="selectIdEndDateBtn" />
                            <span class="iconfont">&#xe6ab;</span>
                        </div>
                        <div class="inputItem">
                            <div class="labelTit">
                                <label>
                                    <i>*</i>
                                    证件照片：
                                </label>
                            </div>
                            <div class="businessLicense">
                                <van-uploader
                                    v-model="positive"
                                    :max-count="1"
                                    :after-read="
                                        (file) => {
                                            return afterRead(file, (type = 'positive'));
                                        }
                                    "
                                    @oversize="onOversize"
                                >
                                    <div icon="plus" type="primary">
                                        <div class="updateLicense">
                                            <div class="updateTop">
                                                <img src="../../assets/images/shenfenz@2x.png" alt="" />
                                            </div>
                                            <div class="updateBottom">身份证人像面</div>
                                        </div>
                                    </div>
                                    <template #preview-cover="{ file }">
                                        <div class="preview-cover van-ellipsis">身份证人像面</div>
                                    </template>
                                </van-uploader>
                            </div>
                            <div class="businessLicense">
                                <van-uploader
                                    v-model="backIdImg"
                                    :max-count="1"
                                    :after-read="
                                        (file) => {
                                            return afterRead(file, (type = 'back'));
                                        }
                                    "
                                    @oversize="onOversize"
                                >
                                    <div icon="plus" type="primary">
                                        <div class="updateLicense">
                                            <div class="updateTop">
                                                <img src="../../assets/images/shenfenzb@2x.png" alt="" />
                                            </div>
                                            <div class="updateBottom">身份证国徽面</div>
                                        </div>
                                    </div>
                                    <template #preview-cover="{ file }">
                                        <div class="preview-cover van-ellipsis">身份证国徽面</div>
                                    </template>
                                </van-uploader>
                            </div>
                            <div class="businessLicense">
                                <van-uploader
                                    v-model="handHeld"
                                    :max-count="1"
                                    :after-read="
                                        (file) => {
                                            return afterRead(file, (type = 'handHeld'));
                                        }
                                    "
                                    @oversize="onOversize"
                                >
                                    <div icon="plus" type="primary">
                                        <div class="updateLicense">
                                            <div class="updateTop">
                                                <img src="../../assets/images/shouchishenfenz@2x.png" alt="" />
                                            </div>
                                            <div class="updateBottom">手持证件照</div>
                                        </div>
                                    </div>
                                    <template #preview-cover="{ file }">
                                        <div class="preview-cover van-ellipsis">手持证件照</div>
                                    </template>
                                </van-uploader>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <button class="nextBtn" @click="next" v-show="active < 2">下一步</button>
            <button class="nextBtn" @click="submitForm" v-show="active > 1">提交</button>
        </div>

        <!-- 地区选择弹窗 -->
        <van-popup v-model="show" round position="bottom" :style="{ height: '40%' }">
            <van-area title="请选择地区" :area-list="areaList" @confirm="selectArea" @cancel="closeSelect" />
        </van-popup>

        <!-- 身份证日期、证件类型弹窗（原有） -->
        <van-popup v-model="idCardStartShow" round position="bottom" :style="{ height: '40%' }">
            <van-datetime-picker
                v-model="idCardStartDate"
                type="date"
                title="请选择身份证开始时间"
                :min-date="minDate"
                :max-date="maxDate"
                :formatter="formatter"
                @confirm="selectIdCardStartTime"
                @cancel="closeIdCardStartTime"
            />
        </van-popup>
        <van-popup v-model="idCardEndShow" round position="bottom" :style="{ height: '40%' }">
            <van-datetime-picker
                v-model="idCardEndDate"
                type="date"
                title="请选择身份证到期时间"
                :min-date="minDate"
                :max-date="maxDate"
                :formatter="formatter"
                @confirm="selectIdCardEndTime"
                @cancel="closeIdCardEndTime"
            />
        </van-popup>
        <van-popup v-model="idTypeShow" round position="bottom" :style="{ height: '40%' }">
            <van-picker title="请选择证件类型" show-toolbar :columns="columns" @confirm="onConfirm" @cancel="onCancel" />
        </van-popup>

        <!-- 地图选点弹窗 -->
        <van-popup v-model="mapShow" round position="bottom" :style="{ height: '80%' }">
            <div style="padding: 10px 12px 0 12px">
                <div style="display: flex; align-items: center; margin-bottom: 8px">
                    <input
                        v-model="mapSearchKeyword"
                        type="text"
                        placeholder="搜索地点，例如：某某商场、某某小区"
                        style="flex: 1; height: 32px; line-height: 32px; border: 1px solid #ddd; border-radius: 4px; padding: 0 8px; font-size: 12px"
                    />
                    <button
                        type="button"
                        @click="searchPlace"
                        style="margin-left: 8px; height: 32px; padding: 0 10px; border: none; background: #333333; color: #ffebc4; font-size: 12px"
                    >
                        搜索
                    </button>
                </div>

                <!-- 地图 -->
                <div id="amapContainerMobile" style="width: 100%; height: 260px"></div>

                <!-- 搜索结果列表（移进来） -->
                <ul v-if="searchResults.length" style="margin-top: 8px; max-height: 340px; overflow-y: auto; padding: 0 4px">
                    <li
                        v-for="item in searchResults"
                        :key="item.id"
                        @click="chooseSearchResult(item)"
                        style="padding: 6px 4px; border-bottom: 1px solid #eee; font-size: 12px; cursor: pointer"
                    >
                        <div style="color: #333; font-weight: 500">{{ item.name }}</div>
                        <div style="color: #666; margin-top: 2px">{{ item.address }}</div>
                    </li>
                </ul>

                <!-- 当前选中 -->
                <p v-if="tempAddress" style="margin-top: 6px; font-size: 12px; color: #666">当前选中：{{ tempAddress }}（{{ tempLng }}, {{ tempLat }}）</p>

                <!-- 底部按钮 -->
                <div style="text-align: right; margin-top: 10px">
                    <button
                        type="button"
                        @click="mapShow = false"
                        style="margin-right: 10px; height: 32px; padding: 0 14px; border: 1px solid #ddd; background: #fff; font-size: 12px"
                    >
                        取消
                    </button>
                    <button type="button" @click="confirmMapLocation" style="height: 32px; padding: 0 14px; border: none; background: #333333; color: #ffebc4; font-size: 12px">
                        确定
                    </button>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import { Area, Popup, DatetimePicker, Uploader, Toast, Picker } from 'vant';
import api from '@/api';
import { listSearchMixin } from '@/config/mixin';
import AreaList from '../../util/area';
export default {
    mixins: [listSearchMixin],
    name: 'mPersonalBusiness',
    components: {
        [Area.name]: Area,
        [Popup.name]: Popup,
        [DatetimePicker.name]: DatetimePicker,
        [Uploader.name]: Uploader,
        [Toast.name]: Toast,
        [Picker.name]: Picker
    },
    data() {
        return {
            active: 1,
            areaList: AreaList,
            show: false,
            minDate: new Date(1960, 1, 1),
            maxDate: new Date(2077, 12, 31),
            idCardStartDate: '',
            idCardEndDate: '',
            startDateShow: false,
            endDateShow: false,
            idCardStartShow: false,
            idCardEndShow: false,
            idTypeShow: false,
            idType: '',
            backIdImg: [],
            positive: [],
            handHeld: [],
            shopAdress: '', // 店铺地区
            subjectRegion: '', // 注册地址地区
            personalForm: {
                shopName: '', // 店铺名称
                shopPhone: '', // 手机号
                servicePhone: '', // 客服电话
                chargePersonName: '', // 店铺负责人
                chargePersonPhone: '', // 负责人电话
                shopAdress: '', // 店铺地址
                shopAdressProvince: '', // 店铺地址省
                shopAdressCity: '', // 店铺地址市
                storeAddressDetail: '', // 店铺详细地址
                personalName: '', // 经营者姓名
                personalCardType: '', // 身份证类型
                personalIdCard: '', // 经营者身份证号码
                personalCardStartTime: '', // 证件有效开始时间
                personalCardEndTime: '', // 证件有效结束时间
                personalCardPositive: '', // 身份证正面照
                personalCardSide: '', // 身份证反面照
                personalCardHand: '', // 手持证件照
                // 新增：经纬度
                lng: '',
                lat: ''
            },
            // 地图相关
            searchResults: [], // 搜索结果列表
            // 地图相关
            mapShow: false,
            mapInstance: null,
            placeSearch: null,
            mapSearchKeyword: '',
            tempLng: '',
            tempLat: '',
            tempAddress: '',

            idCardList: [],
            dictName: '证件类型',
            columns: []
        };
    },
    mounted() {
        this.getDictList();
        this.idCardStartDate = new Date();
        this.idCardEndDate = new Date();
    },
    methods: {
        /* ====== 新增：地图相关 ====== */
        openMapDialog() {
            if (!this.personalForm.shopAdressProvince || !this.personalForm.shopAdressCity) {
                Toast.fail('请先选择店铺所在省市区');
                return;
            }

            this.mapShow = true;
            this.$nextTick(() => {
                this.initMap(); // 只初始化/resize 地图
            });
        },
        initMap() {
            const self = this;

            // eslint-disable-next-line no-undef
            if (!window.AMap) {
                console.error('AMap 未加载，请检查 index.html 中的高德 JS 引用');
                return;
            }

            // 第一次：创建 map 和 marker
            if (!this.mapInstance) {
                // eslint-disable-next-line no-undef
                const map = new AMap.Map('amapContainerMobile', {
                    zoom: 14,
                    center: [104.06, 30.67] // 初始随便给一个，后面会被 locateByRegion 覆盖
                });
                this.mapInstance = map;

                // eslint-disable-next-line no-undef
                this.mapMarker = new AMap.Marker({
                    offset: new AMap.Pixel(-12, -36) // 让 marker 尖端落在点击点
                });
                this.mapInstance.add(this.mapMarker);

                // 点击地图选点（整段替换原来的 map.on('click', ...)）
                map.on('click', (e) => {
                    self.searchResults = [];
                    const lng = e.lnglat.getLng();
                    const lat = e.lnglat.getLat();
                    self.tempLng = lng;
                    self.tempLat = lat;

                    // 1. marker 跟着点走
                    if (self.mapMarker) {
                        self.mapMarker.setPosition([lng, lat]);
                    }

                    // 2. 调用 Web 服务逆地理编码
                    const key = 'abe69f24bf9e8f9fa524e6733fb998cc';
                    const url = `https://restapi.amap.com/v3/geocode/regeo?` + `key=${key}&location=${lng},${lat}&extensions=all&radius=50&batch=false`;

                    fetch(url)
                        .then((res) => res.json())
                        .then((data) => {
                            console.log('regeo api result =', data);
                            if (data.status === '1' && data.regeocode) {
                                const regeocode = data.regeocode;
                                const fullAddress = regeocode.formatted_address || '';

                                self.tempAddress = fullAddress; // 当前选中展示
                                self.personalForm.storeAddressDetail = fullAddress; // 详细地址输入框
                                self.personalForm.lng = lng; // 表单经度
                                self.personalForm.lat = lat; // 表单纬度
                            } else {
                                console.warn('逆地理编码失败：', lng, lat, data);
                                self.tempAddress = '';
                            }
                        })
                        .catch((err) => {
                            console.error('调用逆地理编码接口异常：', err);
                        });
                });

                // 搜索插件
                // eslint-disable-next-line no-undef
                AMap.plugin(['AMap.PlaceSearch', 'AMap.AutoComplete'], () => {
                    // eslint-disable-next-line no-undef
                    self.placeSearch = new AMap.PlaceSearch({
                        map: self.mapInstance
                    });
                });
            } else {
                // 已有 map，只需要 resize 一下
                this.mapInstance.resize();
            }

            // 有历史经纬度的话，先按历史经纬度落点
            if (this.personalForm.lng && this.personalForm.lat) {
                const lng = Number(this.personalForm.lng);
                const lat = Number(this.personalForm.lat);
                if (!Number.isNaN(lng) && !Number.isNaN(lat)) {
                    this.mapInstance.setZoom(16);
                    this.mapInstance.setCenter([lng, lat]);
                    if (this.mapMarker) {
                        this.mapMarker.setPosition([lng, lat]);
                    }
                }
            }
            // 再根据当前省市区进行一次地理编码，移动中心和 marker
            const region = (this.personalForm.shopRegionFull || this.shopAdress || '').replace(/-/g, '').trim();
            console.log('454 region =', region, this.mapInstance);

            // 这里不再用 geocoder.getLocation，而是直接调用高德 Web 服务的地理编码接口
            if (region && this.mapInstance) {
                // 用你 index.html 里 script 上的 key
                const key = 'abe69f24bf9e8f9fa524e6733fb998cc';
                const url = `https://restapi.amap.com/v3/geocode/geo?key=${key}&address=${encodeURIComponent(region)}`;

                fetch(url)
                    .then((res) => res.json())
                    .then((data) => {
                        if (data.status === '1' && data.geocodes && data.geocodes.length > 0) {
                            const locStr = data.geocodes[0].location; // 例如 "123.456,45.678"
                            if (locStr) {
                                const [lngStr, latStr] = locStr.split(',');
                                const lng = Number(lngStr);
                                const lat = Number(latStr);
                                if (!Number.isNaN(lng) && !Number.isNaN(lat)) {
                                    this.mapInstance.setZoom(14);
                                    this.mapInstance.setCenter([lng, lat]);
                                    if (this.mapMarker) {
                                        this.mapMarker.setPosition([lng, lat]);
                                    }
                                    this.tempLng = lng;
                                    this.tempLat = lat;
                                    this.tempAddress = data.geocodes[0].formatted_address || region;
                                }
                            }
                        } else {
                            console.warn('根据地区地理编码失败：', region, data);
                        }
                    })
                    .catch((err) => {
                        console.error('调用地理编码接口异常：', err);
                    });
            }
        },
        searchPlace() {
            const keyword = (this.mapSearchKeyword || '').trim();
            if (!keyword) {
                Toast.fail('请输入搜索关键字');
                return;
            }

            const key = 'abe69f24bf9e8f9fa524e6733fb998cc'; // Web服务 Key
            const city = this.personalForm.shopAdressCity || '';

            const params = new URLSearchParams({
                key,
                keywords: keyword,
                city, // 不想限定城市可以删掉
                offset: '20',
                page: '1',
                extensions: 'all'
            });

            const url = `https://restapi.amap.com/v3/place/text?${params.toString()}`;

            fetch(url)
                .then((res) => res.json())
                .then((data) => {
                    console.log('place/text api result =', data);

                    if (data.status === '1' && data.pois && data.pois.length > 0) {
                        // 把结果转换成我们列表要用的结构
                        this.searchResults = data.pois
                            .filter((poi) => poi.location)
                            .map((poi) => {
                                const [lngStr, latStr] = poi.location.split(',');
                                return {
                                    id: poi.id,
                                    name: poi.name,
                                    address: poi.address || poi.adname || '',
                                    lng: Number(lngStr),
                                    lat: Number(latStr)
                                };
                            });

                        if (!this.searchResults.length) {
                            Toast.fail('未找到带坐标的地点，请尝试换一个关键字');
                        }
                    } else {
                        this.searchResults = [];
                        Toast.fail('未找到相关地点，请尝试换一个关键字');
                    }
                })
                .catch((err) => {
                    console.error('调用关键字搜索接口异常：', err);
                    this.searchResults = [];
                    Toast.fail('地点搜索失败，请稍后再试');
                });
        },
        confirmMapLocation() {
            if (!this.tempLng || !this.tempLat) {
                Toast.fail('请先在地图上点击选择位置或搜索选择地点');
                return;
            }
            this.personalForm.lng = this.tempLng;
            this.personalForm.lat = this.tempLat;
            if (this.tempAddress) {
                this.personalForm.storeAddressDetail = this.tempAddress;
            }
            this.mapShow = false;
        },
        chooseSearchResult(item) {
            const { lng, lat, name, address } = item;
            if (Number.isNaN(lng) || Number.isNaN(lat)) {
                Toast.fail('该地点坐标异常');
                return;
            }

            // 1. 移动地图中心和缩放
            if (this.mapInstance) {
                this.mapInstance.setCenter([lng, lat]);
                this.mapInstance.setZoom(16);
            }

            // 2. 移动 marker
            if (this.mapMarker) {
                this.mapMarker.setPosition([lng, lat]);
            }

            // 3. 组合展示用地址
            const fullAddress = (name || '') + (address ? ' ' + address : '');

            // 4. 更新“当前选中”
            this.tempLng = lng;
            this.tempLat = lat;
            this.tempAddress = fullAddress;

            // 5. 回填到表单
            this.personalForm.lng = lng;
            this.personalForm.lat = lat;
            this.personalForm.storeAddressDetail = fullAddress;
        },
        /* ====== 原有逻辑保持不变 ====== */
        getDictList() {
            let self = this;
            let params = {
                url: api.getByName + '?dictName=' + self.dictName,
                method: 'GET'
            };
            self.sendReq(params, (res) => {
                if (res.code === '') {
                    self.idCardList = res.data;
                    self.idCardList.forEach((item) => {
                        var dictData = {};
                        dictData['text'] = item.dictName;
                        dictData['value'] = item.dictId;
                        self.columns.push(dictData);
                        console.log(self.columns, 'idList');
                    });
                }
            });
        },
        showPopup() {
            this.show = true;
        },
        next() {
            this.active++;
        },
        selectArea(address) {
            // address[0] 省，address[1] 市，address[2] 区/县
            this.shopAdress = `${address[0].name}-${address[1].name}-${address[2].name}`;
            this.personalForm.shopAdressProvince = address[0].name;
            this.personalForm.shopAdressCity = address[1].name;

            // 新增：保存区/县 + 完整地区字符串，用于地图地理编码
            this.personalForm.shopAdressDistrict = address[2].name;
            this.personalForm.shopRegionFull = `${address[0].name}${address[1].name}${address[2].name}`;

            console.log('选中地区：', this.personalForm.shopRegionFull);
            this.show = false;
        },
        closeSelect() {
            this.show = false;
        },
        selectIdStartDateBtn() {
            this.idCardStartShow = true;
        },
        selectIdEndDateBtn() {
            this.idCardEndShow = true;
        },
        dateTime(value) {
            let date = value;
            let m = date.getMonth() + 1;
            let d = date.getDate();
            if (m >= 1 && m <= 9) {
                m = '0' + m;
            }
            if (d >= 0 && d <= 9) {
                d = '0' + d;
            }
            return date.getFullYear() + '年-' + m + '月-' + d + '日';
        },
        idTypeShowFn() {
            this.idTypeShow = true;
        },
        // 选择证件类型
        onConfirm(type) {
            this.idType = type.text;
            this.personalForm.personalCardType = type.value;
            this.idTypeShow = false;
        },
        onCancel() {
            this.personalForm.personalCardType = '';
            this.idTypeShow = false;
        },
        // 选择证件日期开始时间
        selectIdCardStartTime(value) {
            this.personalForm.personalCardStartTime = this.dateTime(value);
            this.idCardStartShow = false;
        },
        // 取消选择身份证开始时间
        closeIdCardStartTime() {
            this.idCardStartShow = false;
        },
        // 证件到期时间
        selectIdCardEndTime(value) {
            this.personalForm.personalCardEndTime = this.dateTime(value);
            this.idCardEndShow = false;
        },
        // 取消选择身份证到期时间
        closeIdCardEndTime() {
            this.idCardEndShow = false;
        },
        changeActive(index) {
            this.active = index;
        },
        formatter(type, val) {
            if (type === 'year') {
                return `${val}年`;
            } else if (type === 'month') {
                return `${val}月`;
            } else if (type === 'day') {
                return `${val}日`;
            }
            return val;
        },
        // 禁止弹出键盘
        noBomBox(Event) {
            document.activeElement.blur();
        },
        afterRead(file, type) {
            let formData = new FormData();
            formData.append('file', this.dataURLtoFileFun(file.content, file.file.name));
            let self = this;
            let params = {
                url: api.upload,
                method: 'POST',
                contentType: 'multipart/form-data',
                data: formData
            };
            self.sendReq(params, (res) => {
                if (res.code === '200') {
                    if (type === 'positive') {
                        self.personalForm.personalCardPositive = res.data.url;
                    } else if (type === 'back') {
                        self.personalForm.personalCardSide = res.data.url;
                    } else if (type === 'handHeld') {
                        self.personalForm.personalCardHand = res.data.url;
                    }
                } else {
                    Toast.fail(res.message);
                }
            });
        },
        dataURLtoFileFun(dataurl, filename) {
            let arr = dataurl.split(',');
            let mime = arr[0].match(/:(.*?);/)[1];
            let bstr = atob(arr[1]);
            let n = bstr.length;
            let u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, { type: mime });
        },
        onOversize(file) {
            console.log(file);
            Toast.fail('文件大小不能超过 500kb');
        },
        // 提交申请
        // 新增（2026-10-18，第 118 条）：展示入驻时选择的「开通功能」
        funcText() {
            const codes = (this.$route && this.$route.query && this.$route.query.funcCodes) || '';
            const map = { 1: '线下展示', 2: '线上商城', 3: '供应链商城' };
            return codes.split(',').filter((c) => map[c]).map((c) => map[c]).join(' + ');
        },
        submitForm() {
            let self = this;
            self.personalForm.shopAdress = '';
            let reg = /^1[13456789]\d{9}$/;
            var idReg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
            self.personalForm.shopPhone = self.personalForm.servicePhone;
            self.personalForm.shopAdress = `${self.shopAdress}，${self.personalForm.storeAddressDetail}`;
            if (self.personalForm.shopName === '') {
                Toast.fail('请输入店铺名称');
                return false;
            }
            if (self.personalForm.servicePhone === '') {
                Toast.fail('请输入客服电话');
                return false;
            } else if (!reg.test(self.personalForm.servicePhone)) {
                Toast.fail('客服电话号格式错误');
                return false;
            }
            if (self.personalForm.chargePersonName === '') {
                Toast.fail('请输入店铺负责人');
                return false;
            }
            if (self.personalForm.chargePersonPhone === '') {
                Toast.fail('请输入负责人电话');
                return false;
            } else if (!reg.test(self.personalForm.chargePersonPhone)) {
                Toast.fail('负责人电话式错误');
                return false;
            }
            if (self.personalForm.shopAdress === '') {
                Toast.fail('请选择所在地区');
                return false;
            }
            if (self.personalForm.storeAddressDetail === '') {
                Toast.fail('请输入详细地址');
                return false;
            }
            if (self.personalForm.personalName === '') {
                Toast.fail('请输入经营者姓名');
                return false;
            }
            if (self.personalForm.personalCardType === '') {
                Toast.fail('请选择证件类型');
                return false;
            }
            if (self.personalForm.personalIdCard === '') {
                Toast.fail('请输入居民身份证号');
                return false;
            } else if (!idReg.test(self.personalForm.personalIdCard)) {
                Toast.fail('身份证号码格式错误');
                return false;
            }
            if (self.personalForm.personalCardStartTime === '') {
                Toast.fail('请选择身份证开始时间');
                return false;
            }
            if (self.personalForm.personalCardEndTime === '') {
                Toast.fail('请选择身份证有效期结束时间');
                return false;
            }
            if (self.personalForm.personalCardPositive === '') {
                Toast.fail('请上传身份证正面照1');
                return false;
            }
            if (self.personalForm.personalCardSide === '') {
                Toast.fail('请上传身份证背面照');
                return false;
            }
            if (self.personalForm.personalCardHand === '') {
                Toast.fail('请上传手持身份证照片');
                return false;
            }
            let params = {
                url: api.personalCheck,
                method: 'POST',
                data: Object.assign({}, self.personalForm, { funcCodes: self.$route ? (self.$route.query.funcCodes || '') : '' })
            };
            self.sendReq(params, (res) => {
                if (res.code === '200') {
                    Toast.success('提交成功');
                    self.$router.push({ path: '/mStatus' });
                } else {
                    Toast.fail(res.message);
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
/* 保持原样不动 */
.mUinitBusiness {
    padding-bottom: 60px;
    .topTitle {
        padding: 0 5%;
        h3 {
            font-size: 21px;
            color: #333333;
            margin-bottom: 22px;
        }
        p {
            font-size: 12px;
            color: #676870;
        }
        margin: 50px 0 28px 0;
    }
    ::v-deep .el-step__head {
        color: #e9eaeb;
        .el-step__icon {
            background: #ffffff;
            width: 50px;
            height: 50px;
            border-radius: 0;
            border: 1px solid #f3f4f5;
        }
    }
    ::v-deep .el-step__head.is-process {
        border-color: #cdcdcd;
    }
    ::v-deep .el-step__line {
        background-color: #f3f4f5;
        height: 1px !important;
        top: 50% !important;
        overflow: hidden;
    }
    ::v-deep .is-finish {
        border-color: #c5aa7b;
        color: #ffffff;
        font-weight: 500 !important;
        .el-step__icon {
            background: #ffffff;
            height: 50px;
            width: 50px;
            color: #c5aa7b;
            border: 1px solid #c5aa7b;
            border-radius: 0;
        }
    }
    ::v-deep .el-step__main {
        .is-finish {
            color: #333333;
        }
    }
    ::v-deep .el-step__title.is-process {
        font-size: 14px;
        color: #999999;
        font-weight: 500;
    }
    ::v-deep .el-step__title.is-wait {
        font-size: 14px;
        color: #676870;
        font-weight: 500;
    }
    ::v-deep .el-step__main {
        .el-step__title {
            font-size: 14px;
        }
        .is-success {
            color: $mainColor;
        }
    }
    .mFormBox {
        padding: 0 5%;
        margin-top: 41px;
        .formTit {
            span {
                font-size: 17px;
                font-weight: bold;
                color: #444444;
                line-height: 18px;
                position: relative;
                i {
                    background: linear-gradient(267deg, #ff8f25 0%, rgba(254, 179, 24, 0.48) 52%, rgba(255, 255, 255, 0) 100%);
                    opacity: 0.7;
                    display: block;
                    height: 11px;
                    width: 100%;
                    bottom: -2px;
                    position: absolute;
                }
            }
        }
        .form {
            margin-top: 25px;
            .inputItem {
                margin-top: 20px;
                .labelTit {
                    display: flex;
                    label {
                        color: #333333;
                        font-weight: 500;
                        font-size: 14px;
                        i {
                            color: $mainColor;
                            font-size: 15px;
                            margin-right: 5px;
                        }
                    }
                }
                input {
                    width: 100%;
                    border-bottom: 1px solid #f6f4f7;
                    height: 50px;
                    line-height: 50px;
                    font-size: 13px;
                    color: #666666;
                    padding-left: 10px;
                }
                input::placeholder {
                    color: #999999;
                }
            }
            .arrow {
                position: relative;
                span {
                    position: absolute;
                    right: 5px;
                    top: 30px;
                    color: #999999;
                }
            }
            .arrowTime {
                position: relative;
                span {
                    position: absolute;
                    right: 5px;
                    top: 20px;
                    color: #999999;
                }
            }
            .describe {
                color: #bbbbbb;
                font-size: 12px;
                margin-top: 10px;
                line-height: 20px;
            }
        }
    }
    .nextBtn {
        display: block;
        margin: 50px auto 0 auto;
        width: 315px;
        height: 42px;
        background: #333333;
        color: $mainColor;
    }
    .businessLicense {
        width: 100%;
        background: #f3f4f5;
        margin-top: 10px;
        display: flex;
        .van-uploader {
            margin: 10px auto;
        }
        ::v-deep .van-uploader__preview-image {
            width: 162px;
            height: 135px;
        }
        .updateLicense {
            width: 162px;
            height: 135px;
            .updateTop {
                display: flex;
                justify-content: center;
                height: 110px;
                align-items: center;
                img {
                    width: 169px;
                    height: 100px;
                }
            }
            .updateBottom {
                width: 162px;
                height: 25px;
                font-size: 13px;
                line-height: 25px;
                color: #999999;
                text-align: center;
            }
        }
    }
}
.preview-cover {
    position: absolute;
    bottom: 0;
    box-sizing: border-box;
    width: 100%;
    padding: 4px;
    color: #fff;
    font-size: 12px;
    text-align: center;
    background: rgba(0, 0, 0, 0.3);
}

.centBox {
    > .el-step {
        .el-step:nth-child(1) {
            .el-step__icon-inner {
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/moblie/mPersonal.vue